import store from '../../../../store/store';
import { filterAndOrderToolsByNamesList, getOrderedToolNamesByDevice, initGroupedTools, TYPE_TOOLSET_ECG } from './toolsetUtils';
import toolNames from './toolNames';
import { toolsConfig } from './toolsConfig';

const showTool = (toolName, config) => {
  switch (toolName) {
    case toolNames.ANONYMIZE:
      return (config.WITH_PATIENT_DISCLOSED);
    default:
      return true;
  }
}

const filterToolsetByECGConditions = (toolset, config) => {
  return toolset.filter((tool) => {
    return showTool(tool.name, config);
  });
};


export const getToolsetECG = () => {
  const { config } = store.getState();

  const toolsetECGOrderedNames = getOrderedToolNamesByDevice(TYPE_TOOLSET_ECG);

  const filteredToolsetECG = filterAndOrderToolsByNamesList(toolsConfig, toolsetECGOrderedNames);
  
  const toolsetECG = filterToolsetByECGConditions(filteredToolsetECG, config);

  return toolsetECG;
};
